module.exports = __webpack_public_path__ + "static/fonts/Metropolis-ExtraBold.f2cf495.woff";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/metropolis/Metropolis-ExtraBold.woff
// module id = 2dfe
// module chunks = 1